var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":true}},[_c('v-overlay',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","width":"6","color":"primary"}})],1),(_vm.provider === 'freee')?_c('freee-form',{attrs:{"provider":_vm.provider}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }